<form [formGroup]="padronesForm" >
  <div formArrayName="items" *ngFor="let item of padronesForm.get('items')['controls']; let i = index">
    <div [formGroupName]="i" class="data-form border-padron">

      <div class="row field-row">
        <mat-label class="col">Tipo</mat-label>
        <mat-form-field appearance="none" class="col">
          <mat-select formControlName="padronTipo" placeholder="Tipo" [disabled]="!canManipulate">
            <mat-option *ngFor="let d of tipos" [value]="d.id">
              {{ d.nombre }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="row field-row">
        <mat-label class="col">Departamento</mat-label>
        <mat-form-field appearance="none" class="col">
          <mat-select formControlName="departamento" placeholder="Departamento" [disabled]="!canManipulate">
            <mat-option *ngFor="let d of departamentos" [value]="d.id.toString()">
              {{ d.nombre }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div *ngIf="!isPadronRural(i)" class="row field-row">
        <mat-label class="col">Localidad</mat-label>
        <mat-form-field appearance="none" class="col">
          <mat-select formControlName="localidad" placeholder="Localidad" [disabled]="!canManipulate">
            <mat-option *ngFor="let l of localidades[i]" [value]="l.LocalidadCodigo.toString()">
              {{ l.LocalidadNombre }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="row field-row">
        <mat-label class="col">Número</mat-label>
        <mat-form-field appearance="none" class="col">
          <input formControlName="padronId" matInput placeholder="Número" [disabled]="!canManipulate" />
        </mat-form-field>
      </div>

      <div class="row field-row">
        <mat-label class="col">Área</mat-label>
        <mat-form-field appearance="none" class="col">
          <input formControlName="padronArea" matInput placeholder="Superficie (ha)" [disabled]="!canManipulate" />
        </mat-form-field>
      </div>

      <div class="btn-contenedor" *ngIf="canManipulate">
        <button (click)="setDeletePadronQuest(i)" mat-button color="warn" *ngIf="!deletePadronQuest[i]">
          <fa-icon icon="trash"></fa-icon>
          <span class="ml-2">Eliminar Padrón</span>
        </button>
        <button (click)="remove(i)" mat-raised-button color="warn" *ngIf="deletePadronQuest[i]">
          <span>¿Seguro desea eliminar?</span>
        </button>

        <button (click)="save(i)" [disabled]="!item.valid || !item.touched" mat-raised-button color="primary" class="btn-small">Guardar</button>
      </div>
    </div>
  </div>
</form>
